$(document).ready(function()
{
    if ( $('#categories_and_filters').length && ('#filter_grid').length )
    {
        var first_filter = $('#first_filter');
        var second_filter = $('#second_filter');
        var third_filter = $('#third_filter');
        var fourth_filter = $('#fourth_filter');
        var freetext_filter = $('#freetext_filter');

        var filter_grid = $('#filter_grid');
        var filter_items = $("#filter_grid .filter-row");

        var total_item_count =  filter_items.length;
        $('#item_count').html(total_item_count);
        var current_item_count = 0;

        var selected_first_filter = null;
        var selected_second_filter  = null;
        var selected_third_filter  = null;
        var selected_fourth_filter  = null;
        var selected_freetext_filter = null;

        var slide_speed = 500;

        var timeout;


        first_filter.change(function () 
        {
            selected_first_filter = ($(this).val() != "" && $(this).val() != "*" ) ? $(this).val() : null;
            implementFilters();
        });

        second_filter.change(function () 
        {
            selected_second_filter = ($(this).val() != "" && $(this).val() != "*" ) ? $(this).val() : null;
            implementFilters();
        });

        third_filter.change(function () 
        {
            selected_third_filter = ($(this).val() != "" && $(this).val() != "*" ) ? $(this).val() : null;
            implementFilters();
        });

        fourth_filter.change(function () 
        {
            selected_fourth_filter = ($(this).val() != "" && $(this).val() != "*" ) ? $(this).val() : null;
            implementFilters();
        });

        freetext_filter.on("input", function()
        {
            if(timeout)
            { 
                clearTimeout(timeout);
            }
            
            timeout = setTimeout(function() 
            {
                selected_freetext_filter = (freetext_filter.val().length > 2) ? freetext_filter.val().toLowerCase() : null;
                implementFilters();
            },500);
            
            
        });

        function implementFilters()
        {
            console.log(selected_first_filter, selected_second_filter, selected_freetext_filter);

            $('#no-matching-items').slideUp( 0 );

            // if no filters applied, open all.
            if (!selected_first_filter && !selected_second_filter && !selected_freetext_filter && !selected_third_filter  && !selected_fourth_filter  )
            {
                current_item_count = filter_items.length;  
                filter_items.slideDown( 500 );                
            }
            else
            {
                current_item_count = 0;
                filter_items.slideUp( 100 );
                active_items = [];
                slide_speed = 500;


                // filter one
                if (selected_first_filter)
                {
                    $.each(filter_items, function(i) 
                    {
                        if ($(this).hasClass(selected_first_filter))
                        {
                            active_items.push($(this));
                        }
                    }); 
                }
                else
                {
                    active_items = filter_items;
                }


                if (selected_second_filter)
                {
                    var temp_active_items = [];
                    if (active_items.length > 0)
                    {
                        //console.log (active_items.length + " items after first filter ");
                        $.each(active_items, function(i) 
                        {
                            if ($(this).hasClass(selected_second_filter))
                            {
                                temp_active_items.push($(this));
                            }
                        }); 

                        active_items = temp_active_items;
                    }
                }

                if (selected_third_filter)
                {
                    var temp_active_items = [];
                    if (active_items.length > 0)
                    {
                        //console.log (active_items.length + " items after first filter ");
                        $.each(active_items, function(i) 
                        {
                            if ($(this).hasClass(selected_third_filter))
                            {
                                temp_active_items.push($(this));
                            }
                        }); 

                        active_items = temp_active_items;
                    }
                }

                if (selected_fourth_filter)
                {
                    var temp_active_items = [];
                    if (active_items.length > 0)
                    {
                        //console.log (active_items.length + " items after first filter ");
                        $.each(active_items, function(i) 
                        {
                            if ($(this).hasClass(selected_fourth_filter))
                            {
                                temp_active_items.push($(this));
                            }
                        }); 

                        active_items = temp_active_items;
                    }
                }

                // filter three
                // this would search for cat titles
                /*if (selected_freetext_filter)
                {
                    var temp_active_items = [];
                    if (active_items.length > 0)
                    {
                        $.each(active_items, function(i) 
                        {
                            var classList = $(this).attr('class').split(/\s+/);
                            $.each(classList, function(index, item) 
                            {
                                console.log(index + " :: " + item  + " :: " + selected_freetext_filter);
                                if (item.indexOf(selected_freetext_filter) >= 0)
                                {
                                    temp_active_items.push($(this));
                                }
                            });

                        }); 

                        active_items = temp_active_items;
                    }
                }*/

                if (selected_freetext_filter)
                {
                    var temp_active_items = [];
                    if (active_items.length > 0)
                    {
                        $.each(active_items, function(i) 
                        {
                            var title = $(this).find('h2.item-title').text();
                            var desc = $(this).find('p.item.desc').text();
                            var combo = (title + " " + desc).toLowerCase();
                            //console.log ( combo, selected_freetext_filter, combo.indexOf(selected_freetext_filter), combo.includes(selected_freetext_filter) );

                            //if (combo.indexOf(selected_freetext_filter) >= 0)
                            if (combo.includes(selected_freetext_filter))
                            {
                                temp_active_items.push($(this));
                            }
                        }); 

                        active_items = temp_active_items;
                        slide_speed = 50;

                    }
                }

                if (active_items.length > 0)
                {
                    $.each(active_items, function(i) 
                    {
                        $(this).slideDown( slide_speed );
                        current_item_count++;
                    });
                }
                //console.log(active_items);
            }

        
            // additional outputs
            $('#item_count').html(current_item_count);

            if (current_item_count == 0)
            {
                $('#no-matching-items').slideDown( 500 );   
            }

        }

    }
});
